/**
 * Deals with menu items labels
 */
export class ProfileMenuItems {
  /**
   * @constructor
   */
  constructor(
    public accountSettings: string = 'account-settings', // NOSONAR
    public logout: string = 'logout' // NOSONAR
  ) {}
}
